import theme from "@/theme";

export const styles = {
  activeButton: {
    height: 32,
    borderRadius: "22px",
    padding: "6px 16px",
    gap: "4px",
    backgroundColor: theme.palette.custom.mainBlue,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  inactiveButton: {
    height: 32,
    border: "1px solid #C6CACE",
    borderRadius: "22px",
    padding: "6px 16px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  activeText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#FFFFFF",
  },
  inactiveText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#52575D",
  },
  dropdown: {
    width: "154px",
    overflow: "visible",
    borderRadius: "8px",
    padding: "8px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 16px 0px #0000001A",
    zIndex: 1300,
  },
  dropdownItem: {
    width: "138px",
    height: "36px",
    borderRadius: "8px",
    padding: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "#F4F5F6",
    },
  },
  dropdownItemSelected: {
    width: "138px",
    height: "36px",
    borderRadius: "8px",
    padding: "8px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#F4F5F6",
  },
  dropdownText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    color: "#2A2D31",
  },
  dropdownTextSelected: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    color: "#2A2D31",
  },
  subDropdown: {
    position: "absolute",
    top: 40,
    left: "calc(100% + 5px)",
    zIndex: 99,
    backgroundColor: "#fff",
    boxShadow: "0px 0px 16px 0px #0000001A",
    borderRadius: "8px",
    padding: "8px",
    minWidth: "154px",
  },
  disabledText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#7D8690",
  },
  tooltipWrapper: {
    width: 169,
    height: 26,
    background: "#000000CC",
    borderRadius: "4px",
    px: "8px",
    py: "4px",
  },

  tooltipText: {
    fontFamily: "Inter",
    fontSize: 12,
    lineHeight: "18px",
    color: "#FFFFFF",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },

  tooltipProps: {
    backgroundColor: "transparent",
    boxShadow: "none",
    padding: 0,
  },
};
